import type { CurrentUser } from "../hooks/useAuthRestApi";

/**
 * 管理者権限が必要なページへのアクセス可否を判定する
 * @param {CurrentUser | null} user - 現在のユーザー情報
 * @return {boolean} アクセス可能な場合はtrue
 */
export const canAccessAdminPages = (user: CurrentUser | null): boolean => {
  if (!user) return false;

  return user.isSystemAdmin === true;
};
